// @ts-nocheck
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { trackItemOutOfStockError } from "@store/Framework/Common/GoogleAnalytics/hooks";
import { itemOutOfStockError } from "@store/Framework/Common/GoogleAnalytics/trackers";
import { useInventoryStatus } from "@store/Framework/Common/Hooks/useInventoryStatus";
import storeConstants from "@store/storeConstants";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { RecursivePartial } from "@toolkit/Framework/Types/Common";

const baseGA = { ...ga };

Object.assign<Toolkit.GoogleAnalytics, RecursivePartial<Toolkit.GoogleAnalytics>>(ga, {
    track: {
        ...ga.track,
        itemOutOfStockError,
    },
    use: {
        ...ga.use,
        trackItemOutOfStockError,
    },
    map: {
        ...ga.map,
        cartLineModel: (cartLine: CartLineModel, options?: Toolkit.GoogleAnalytics.Options) => {
            const baseData = baseGA.map.cartLineModel(cartLine, options);
            if (cartLine) {
                const qtyOrdered = cartLine.qtyOrdered || 0;
                const qtyOnHand = cartLine.qtyOnHand || 0;
                const qty = qtyOrdered ?? 0;
                const { shouldShowTemporaryOutOfStock, shouldShowOnDemand } = useInventoryStatus(
                    qtyOnHand,
                    qty,
                    cartLine.properties?.availabilityCode,
                    cartLine.properties?.quantityOrdered,
                );

                if (shouldShowOnDemand) {
                    return { ...baseData, stock_status: "Sur demande" };
                }
                if (shouldShowTemporaryOutOfStock) {
                    return { ...baseData, stock_status: "Rupture de stock" };
                }
            }
            return baseData;
        },
        productInfosOption: (
            options: Toolkit.GoogleAnalytics.Options | undefined,
            id: string | null,
            ignorePricing?: boolean,
        ) => {
            const baseData = baseGA.map.productInfosOption(options, id, ignorePricing);
            const productInfo = options?.productInfos?.find(x => x.productId === id);
            if (productInfo && productInfo.inventory) {
                const { additionalResults, qtyOnHand } = productInfo.inventory;
                const qty = productInfo?.qtyOrdered ?? 0;
                const { shouldShowTemporaryOutOfStock, shouldShowOnDemand } = useInventoryStatus(
                    qtyOnHand,
                    qty,
                    additionalResults?.availabilityCode,
                    additionalResults?.quantityOrdered,
                );

                if (shouldShowOnDemand) {
                    return { ...baseData, stock_status: "Sur demande" };
                }
                if (shouldShowTemporaryOutOfStock) {
                    return { ...baseData, stock_status: "Rupture de stock" };
                }
            }
            return baseData;
        },
    },
});
